import { SERVICE_TYPE } from '../constant.js';
import { get, post, URLs } from './request';

const getBaseUrl = (serviceType) => {
  switch (serviceType) {
    case SERVICE_TYPE.DELIVERY:
      return `${URLs.api}/on_demand`;
    case SERVICE_TYPE.PICKUP:
      return `${URLs.api}/pickup`;
    case SERVICE_TYPE.DINEIN:
      return `${URLs.api}/dine_in`;
  }
};

export const getDiscounts = async ({ restaurantIds, serviceType }) => {
  const url = getBaseUrl(serviceType);
  const { data } =
    serviceType === SERVICE_TYPE.PICKUP
      ? await post({
        url: `${url}/v2/discounts/fetch`,
        options: { CORS_API: true },
        data: {
          restaurant_ids: restaurantIds,
        },
      })
      : await get({
        url: `${url}/v2/discounts`,
        options: { CORS_API: true },
        data: {
          restaurant_ids: restaurantIds,
        },
      });
  return data;
};
